module.exports = __webpack_public_path__ + "static/media/cl.26a29e42.svg";